import React from 'react';
import { connect } from 'react-redux';
import { currentWidget, popupOpenClose } from '../../../action/action'
import { setSelectedLocation } from '../../../action/hcommerce';
import { setCustomLocation, setMapSnapshot } from '../../action/hCommerce2';
import { HashRouter, Redirect, Link } from "react-router-dom";
import { CMSPath, CMSPath_HTTP } from '../../../config/constant';
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import { sendAnalytics } from '../../../action/homeAction';
import html2canvas from 'html2canvas';
import { GoogleMap, Polygon, useJsApiLoader, Marker, GroundOverlay, Rectangle, GroundOverlayF } from '@react-google-maps/api';


function GoogleMapWeb(props) {


    const API_KEY = 'AIzaSyAFwpDICdlbldOY4tQQRJQkAetrbYMz2NA';

    const { t } = props
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: API_KEY
    })

    const sliceStartIndex = CMSPath.startsWith('https') ? 8 : 7
    const polygonCoords = new URLSearchParams(props.location.search).get("mapValues");
    const polygon_points = JSON.parse(polygonCoords);

    const [goBack, setGoBack] = React.useState(false);
    const [locationErr, setLocationErr] = React.useState(false)
    const [fetchingLocation, setfetchingLocation] = React.useState(true)
    const [mapDeliveryImage, setMapDeliveryImage] = React.useState(null);
    const [disableLocationButton, setDisableLocationButton] = React.useState(true)

    const [coords, setCoords] = React.useState({
        lat: null,
        lng: null
    })

    const [markerCoordinates, setMarkerCoordinates] = React.useState({
        lat: null,
        lng: null
    })


    const polygonOptions = {
        fillColor: "rgba(255,0,0,0.2)",
        fillOpacity: 1,
        strokeColor: "red",
        strokeOpacity: 1,
        strokeWeight: 2,
        clickable: true,
        zIndex: 2
    }

    const getBounds = (polygonPoints) => {

        let latLngNW;
        let latLngSE;
        let latLngBounds;

        if (polygonPoints.length > 0 && polygonPoints[0].lat) {
            latLngNW = new window.google.maps.LatLng(polygonPoints[1].lat, polygonPoints[0].lng);
            latLngSE = new window.google.maps.LatLng(polygonPoints[3].lat, polygonPoints[2].lng);

            latLngBounds = new window.google.maps.LatLngBounds();
            latLngBounds.extend(latLngSE);
            latLngBounds.extend(latLngNW);

            return latLngBounds
        }
        else if (polygonPoints.length > 0 && polygonPoints[0].latitude) {
            latLngNW = new window.google.maps.LatLng(polygonPoints[1].latitude, polygonPoints[0].longitude);
            latLngSE = new window.google.maps.LatLng(polygonPoints[3].latitude, polygonPoints[2].longitude);

            latLngBounds = new window.google.maps.LatLngBounds();
            latLngBounds.extend(latLngSE);
            latLngBounds.extend(latLngNW);

            return latLngBounds
        } else {
            return {}
        }
    }


    const checkMarkerLocation = () => {

        const latLngM = new window.google.maps.LatLng(markerCoordinates.lat, markerCoordinates.lng)
        if (getBounds(polygon_points).contains(latLngM)) {
            setDisableLocationButton(false)
        } else {
            setDisableLocationButton(true)
        }

    }

    const locationError = (err) => {
        let label = {
            ...getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" }),
            "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), storeName: props.storeInfo.storeName, pageName: "MAP",
            "errorMessage": `Unable to fetch location with error: ${err}`
        }

        props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            "MAP - ERROR",
            label,
            0,
            props.guestIsLoggedIn,
            () => { }
        );
    }

    const onLoad = React.useCallback(function callback(map) {
        checkMarkerLocation();
    }, [])

    const changeMarkerLocation = (e) => {
        const latLngMarker = JSON.parse(JSON.stringify(e.latLng));
        setMarkerCoordinates(latLngMarker)
        checkMarkerLocation();
    }


    const confirmLocationHandler = (e) => {
        e.preventDefault();
        setDisableLocationButton(true);

        const lat = markerCoordinates.lat
        const lng = markerCoordinates.lng;
        const zoomLevel = +JSON.parse(props.hcommerce_zoom_mapview).zoomLevel
        const mapView = JSON.parse(props.hcommerce_zoom_mapview).mapView
        const link = `https://maps.google.com/?q=${lat},${lng}&ll=${lat},${lng}&z=${zoomLevel}&t=${mapView}`

        html2canvas(document.querySelector("#google-maps"), { useCORS: true }).then(function (canvas) {
            const googleMapURL = canvas.toDataURL();

            console.log(link);
            props.setCustomLocation(link);
            props.setMapSnapshot(googleMapURL);

            setGoBack(true);
        });
    }

    const openMapHandler = (resp) => {
        setCoords({ lat: resp.coords.latitude, lng: resp.coords.longitude })
        setMarkerCoordinates({ lat: resp.coords.latitude, lng: resp.coords.longitude })
        setfetchingLocation(false)
    }

    React.useEffect(() => {
        if (isLoaded) {
            checkMarkerLocation();
        }
    }, [markerCoordinates])


    React.useEffect(() => {
        navigator.geolocation.getCurrentPosition((resp) => openMapHandler(resp), (err) => { setLocationErr(true); locationError(err) });

        props.setCustomLocation(null);
        props.setMapSnapshot(null);

        if (props.selectedLocation && props.selectedLocation.mapDeliveryImage) {
            if (`${props.selectedLocation.mapDeliveryImage}`.startsWith('http://') ||
                `${props.selectedLocation.mapDeliveryImage}`.startsWith('https://')) {
                setMapDeliveryImage(props.selectedLocation.mapDeliveryImage)
            } else {
                setMapDeliveryImage(`${CMSPath_HTTP}${props.selectedLocation.mapDeliveryImage}`.split("../").join(""))
            }
        }

        let mapEventSent = localStorage.getItem("mapEventSent") == "true"
        if (!mapEventSent) {
            let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })

            props.sendAnalytics(
                props.guestDetail,
                props.currentWidgets.widgetType,
                "MAP",
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), storeName: props.storeInfo.storeName, pageName: "MAP" },
                0,
                props.guestIsLoggedIn,
                () => localStorage.setItem("mapEventSent", true)
            );
        }
    }, [isLoaded])


    return (
        <section id="map-container" className="my-orders open" style={{ backgroundColor: "#fff" }}>
            <div className="orders-container" style={{ height: !locationErr ? "90vh" : "25vh", maxHeight: "unset", bottom: "0" }}>
                <div className="orders-heading">
                    <h5>{t('hcommerce.custom_location.header')}</h5>
                    <Link exact to="/hcommerce2" className="order-toggle">
                        <i onClick={() => {
                            props.setSelectedLocation(null);
                            props.setCustomLocation(null);
                        }} className="fas fa-lg fa-times"></i>
                    </Link>
                </div>
                {(!fetchingLocation || !locationErr) ? <form onSubmit={(e) => { confirmLocationHandler(e) }}>
                    <div className="orders-body-container" style={{ display: "block" }}>
                        <div className="orders-body" style={{ height: "75vh", maxHeight: "unset", minHeight: "unset" }}>
                            <div className="form-row">
                                {(fetchingLocation && !locationErr) && <p style={{}}>{t('hcommerce.custom_location.fetching_location')}</p>}
                                {!fetchingLocation ? <p style={{ color: "red" }}>{t('hcommerce.custom_location.choose_location')}</p> : <br />}
                            </div>
                            <div className="form-row">
                                <p>{t('hcommerce.custom_location.to_change_location')}</p>
                            </div>
                            {!fetchingLocation && <div id='google-maps'> <GoogleMap

                                mapContainerStyle={{ height: "100vh", width: "100%" }}
                                mapTypeId={window.google.maps.MapTypeId.SATELLITE}
                                center={coords}
                                tilt={0}
                                zoom={+JSON.parse(props.hcommerce_zoom_mapview).zoomLevel}
                                onLoad={() => onLoad()}
                            >
                                {/* <Rectangle bounds={getBounds(props.selectedLocation.startPoint)} options={polygonOptions} onClick={(e) => changeMarkerLocation(e)} /> */}
                                <Polygon paths={polygon_points} options={polygonOptions} onClick={(e) => changeMarkerLocation(e)} />
                                <Marker position={markerCoordinates} />
                                {props.selectedLocation && props.selectedLocation.mapDeliveryImage ? <GroundOverlay key={'url'} url={mapDeliveryImage} bounds={(props.selectedLocation && props.selectedLocation.startPoint) ? getBounds(props.selectedLocation.startPoint) : getBounds(polygon_points)} /> : null}
                            </GoogleMap> </div>}
                        </div>
                        <div className="controls">
                            {!fetchingLocation ? <input type="submit" name="Set Location" value={t('hcommerce.custom_location.set_location')} disabled={disableLocationButton} style={{ opacity: (disableLocationButton) ? "0.3" : "1" }} />
                                : <input type="submit" disabled={true} name="Set Location" value={"Please wait..."} style={{ opacity: "0.8" }} />}
                        </div>
                    </div>
                </form>
                    : <form onSubmit={(e) => {
                        e.preventDefault();
                        setGoBack(true)
                    }}>
                        <div className="orders-body-container" style={{ display: "block" }}>
                            <div className="orders-body" style={{ maxHeight: "unset", minHeight: "unset" }}>
                                <div className="form-row">
                                    <p>{t('hcommerce.custom_location.unable_to_fetch_location')}</p>
                                    {/* <p>{t('hcommerce.custom_location.to_detect_location')}, <a style={{ color: "blue" }} onClick={(e) => setAskLocation(!askLocation)}>{t('hcommerce.custom_location.enable_location')}</a></p> */}
                                </div>
                            </div>
                            <div className="controls">
                                <input type="submit" name="Return to Check-out" value="Return to Check-out" />
                            </div>
                        </div>

                    </form>}
            </div>

            {goBack ? <HashRouter>
                <Redirect to={`/hcommerce2?mapOpened=${true}`} />
            </HashRouter> : null}

        </section>
    )
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        selectedLocation: state.store.Hcommerce.selectedLocation,
        hcommerce_zoom_mapview: state.store.home.clientConfig.extraConfigParam && state.store.home.clientConfig.extraConfigParam.HCOMMERCE_ZOOM_MAPVIEW
            ? state.store.home.clientConfig.extraConfigParam.HCOMMERCE_ZOOM_MAPVIEW : '{"zoomLevel" : "20", "mapView" : "k"}',
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        storeInfo: state.store.Hcommerce.storeInfo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
    }
}


export default connect(mapStateToProps, {
    currentWidget,
    setCustomLocation,
    setSelectedLocation,
    setMapSnapshot,
    popupOpenClose,
    sendAnalytics
})(withTranslation('translations')(GoogleMapWeb));